import { SideBarItem } from '../../../types';

let options: Array<SideBarItem>;
options = [
  {
    icon: 'home',
    url: '',
    label: 'Home',
    excludeRoles: [],
    exact: true,
    next: true
  },
  {
    icon: 'team',
    url: 'klanten',
    label: 'Klanten',
    excludeRoles: ['distributor'],
    exact: false,
    next: false
  },
  {
    icon: 'user',
    url: 'profiel',
    label: 'Profiel',
    excludeRoles: ['distributor'],
    exact: false,
    next: false
  },
  {
    icon: 'calendar',
    url: 'afwezigheid',
    label: 'Afwezigheid',
    excludeRoles: ['distributor'],
    exact: false,
    next: false
  },
  {
    icon: 'calendar',
    url: 'inzetbaarheid',
    label: 'Inzetbaarheid',
    excludeRoles: ['distributor'],
    exact: false,
    next: false
  },
  {
    icon: 'deployment-unit',
    url: 'routes',
    label: 'Routes',
    excludeRoles: [],
    exact: false,
    next: false
  },
  {
    icon: 'euro',
    url: 'betalingen',
    label: 'Betalingen',
    excludeRoles: ['distributor'],
    exact: false,
    next: true
  },
  {
    icon: 'message',
    url: 'maaltijdbeoordelingen',
    label: 'Maaltijdbeoordelingen',
    excludeRoles: ['distributor'],
    exact: false,
    next: true
  }
];

export default options;
